// extracted by mini-css-extract-plugin
export default {"modal":"ModalFileSizeError_modal__XX23x","title":"ModalFileSizeError_title__47YLj","text":"ModalFileSizeError_text__y25vX"};